<script lang="ts">
  import { AppState } from '../../etc/stores';

  export let color = $AppState.theme.colors.typography;
  export let size = 12;
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.24264 10.4853L4 6.24264L8.24264 2"
    stroke={color}
    stroke-width="1.5"
  />
</svg>
